import MarketingLayout from "../../components/marketing/MarketingLayout"
import MarketingSeo from "../../components/marketing/MarketingSeo"
import { measurementStudioSalesMailto } from "../../components/marketing/salesLinks"
import { Button } from "../../components/ui"

const principles = [
  ["Health before reporting", "Trustworthy dashboards start with healthy tagging, configuration, and data collection."],
  ["Consistent client QA", "Every account should be checked against the same clear expectations, no matter who runs the audit."],
  ["Clear next actions", "Cross-account visibility matters most when it shows the team exactly where to focus next."],
]

export default function MarketingAbout() {
  return (
    <MarketingLayout>
      <MarketingSeo
        title="About Jarbod | Measurement Studio"
        description="Jarbod builds Measurement Studio for tagging health and data-quality operations, plus ASC TuneUp for automotive dealership teams."
        path="/about"
      />
      <section className="marketing-page-hero">
        <div className="marketing-container marketing-page-hero__inner">
          <p className="marketing-eyebrow">About Jarbod</p>
          <h1>Measurement quality should be operated—not rediscovered after it breaks.</h1>
          <p>
            Jarbod builds products that help teams check tagging health, protect
            analytics data quality, and keep account settings aligned with a
            standard they control.
          </p>
        </div>
      </section>

      <section className="marketing-section marketing-section--first">
        <div className="marketing-container marketing-about-grid">
          <div className="marketing-about-statement">
            <p className="marketing-eyebrow">Why Measurement Studio</p>
            <h2>A moving stack needs an operating rhythm.</h2>
          </div>
          <div className="marketing-about-copy">
            <p>
              Websites change, tags are republished, properties evolve, vendors
              rotate, and advertising accounts multiply. Small implementation
              issues quietly become reporting and decision-making problems.
            </p>
            <p>
              Measurement Studio gives multi-account teams a neutral workspace
              for that operating rhythm. ASC TuneUp applies the same discipline
              through an automotive-specific product built around dealerships.
            </p>
          </div>
        </div>
      </section>

      <section className="marketing-section marketing-section--surface">
        <div className="marketing-container">
          <div className="marketing-section-heading">
            <p className="marketing-eyebrow">How Jarbod thinks</p>
            <h2>Focused on the work behind dependable measurement.</h2>
          </div>
          <div className="marketing-principles">
            {principles.map(([title, description], index) => (
              <article key={title}><span>0{index + 1}</span><h3>{title}</h3><p>{description}</p></article>
            ))}
          </div>
        </div>
      </section>

      <section className="marketing-section marketing-section--cta">
        <div className="marketing-container marketing-cta-panel">
          <div>
            <p className="marketing-eyebrow">Work with Jarbod</p>
            <h2>Build the analytics QA program your client accounts need.</h2>
          </div>
          <Button as="a" href={measurementStudioSalesMailto} size="lg">Email sales</Button>
        </div>
      </section>
    </MarketingLayout>
  )
}

